module.exports = __webpack_public_path__ + "img/badesaba-logo.aea0e375.svg";